import { useState } from 'react';
import Styles from '../Login.module.css';
import s2 from './ForgetPassword.module.css';
import {fetchSecurityQuestion} from '../../api/login';
import {setSecurityQuestion, setUname} from '../../store/actions'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const ForgetPassword = ()=>{
    const [username,setUsername] = useState(''); //记录username
    const [error,setError] = useState(''); //记录报错
    const navigate = useNavigate(); //获取navigate函数

    //初始化dispatch
    const dispatch = useDispatch();

    const handleSubmit = async (event) =>{
        event.preventDefault();//阻止表单默认提交行为（避免刷新页面）
        
        const response = await fetchSecurityQuestion(username);

        try {
            //请求成功
            if(response.data.code===200){
                //Redux保存username和securityquestion状态
                dispatch(setUname(username));
                dispatch(setSecurityQuestion(response.data.data)); 
                
                //跳转
                navigate('/login/verifySecurityQuestion');
                // window.location.href='/login/verifySecurityQuestion' 不适用这个，因为会导致页面刷新，进而redux状态丢失
            }else{
                setError(response.data.message || '用户不存在')
            }
        } catch (error) {
            setError('网络请求失败，服务器可能未启动');
        }
    }

    //获取到输入的值并添加进状态
    const handleChange =(event)=>{
        const {value} = event.target;
        setUsername(value);
    }

    return (
        <div className={Styles.common}>
            <form onSubmit={handleSubmit} className={Styles.common}>
                <input 
                    value={username} // 输入值绑定到状态
                    onChange={handleChange} //绑定事件
                    type='text' 
                    placeholder='USERNAME'
                    required = 'required' 
                    className={Styles.inputWithUsrnameIcon}/>
                <button type='submit' className={s2.button}>SUBMIT</button>
                {error&&<p style={{color:'red'}}>{error}</p>}
            </form>
        </div>
    )
}

export default ForgetPassword;
